import { ComponentTypes } from '../Data/Components';
import { shouldShowComponent } from './conditionality';

const TRACKING_PARAMS = {
  revtype: 'hybridtier',
};

const getPageUrlParameters = (pageUrl) => {
  const url = new URL(pageUrl);
  const params = new URLSearchParams(url.search);
  return params;
};

/**
 * Appends tracking parameters to a URL if the target page is an appwiki page.
 * If shouldForwardUrlParams is true, appends query parameters from the parent page to the target page.
 *
 * @param {string} targetPageUrl - The URL to append parameters to.
 * @param {string} parentPageUrl - The URL of the parent page.
 * @param {boolean} shouldForwardUrlParams - Whether to append query parameters from the parent page to the target page.
 * @returns {URL} The URL with parameters appended.
 */
export const getLinkWithTrackingParameters = ({
  targetPageUrl,
  parentPageUrl,
  shouldForwardUrlParams,
}) => {
  const url = new URL(targetPageUrl);
  const params = new URLSearchParams(url.search);

  if (url.hostname.includes('appwiki')) {
    // Append tracking parameters to the target page for appwiki pages
    Object.keys(TRACKING_PARAMS).forEach((key) => {
      params.append(key, TRACKING_PARAMS[key]);
    });
    // Append parent page query parameters to the target page for appwiki pages
    Array.from(getPageUrlParameters(parentPageUrl).entries()).forEach(
      ([key, value]) => {
        if (key !== 'question_page') {
          params.set(key, value);
        }
      }
    );
  } else if (shouldForwardUrlParams) {
    // Append parent page query parameters to the click out link, which means users will be able to pass params to the target page.
    Array.from(getPageUrlParameters(parentPageUrl).entries()).forEach(
      ([key, value]) => {
        if (key !== 'question_page') {
          params.set(key, value);
        }
      }
    );
  }

  url.search = params.toString();
  return new URL(url.toString());
};

const isCpcSupplierCard = (component) =>
  component?.component?.type === ComponentTypes.SUPPLIER_CARD &&
  component?.component?.additionalSettings?.cta_link_url;

export const isCpcSupplierCardOnPage = ({
  currentPage,
  components,
  dynamicNewsletterName,
  phoneNumberCountryCode,
  subcategoryId,
}) => {
  return Object.values(components).some(
    (component) =>
      component?.component?.page === currentPage &&
      isCpcSupplierCard(component) &&
      shouldShowComponent(
        components,
        component,
        dynamicNewsletterName,
        phoneNumberCountryCode,
        subcategoryId
      )
  );
};

export const getSupplierNameToDisplay = ({
  brandLogoUrl,
  brandName,
  shouldDisplayBrandName,
}) => {
  if (!brandLogoUrl || shouldDisplayBrandName) {
    return brandName;
  }

  return undefined;
};
